<template>
    <div :style="{'max-width': '99%', 'width': '98%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">

        <!-- Enhanced Detailed View Modal -->
      <b-modal id="modal-detailed-view" scrollable
        :title="`DETAILED SELLING HISTORY - ${selectedProduct ? selectedProduct.product_name : ''} (${selectedProduct ? selectedProduct.sku : ''})`"
        size="xl"
        hide-footer
        style="min-height: 700px;">

    <div v-if="selectedProduct" class="detailed-modal">
        <!-- Product Summary -->
        <b-card class="mb-3">
            <b-row>
                <b-col>
                    <strong>Category:</strong> {{ packet.categoriesdict[selectedProduct.category_id] }}
                </b-col>
                <b-col>
                    <strong>Total Locations:</strong> {{ getUniqueLocations }}
                </b-col>
                <b-col>
                    <strong>Total Salespeople:</strong> {{ getUniqueSalespeople }}
                </b-col>
                <b-col>
                    <strong>Total Units Sold:</strong> {{ getDetailedTotalSold }}
                </b-col>
            </b-row>
        </b-card>

        <!-- Modal Filters -->
        <b-card class="mb-3">
            <b-row class="filters-row">
                <b-col md="4">
                    <label><strong>DATE RANGE</strong></label>
                    <b-form-select :options="dateRangeOptions" v-model="modalDateRange" @change="fetchDetailedData" class="mb-2">
                    </b-form-select>
                </b-col>
                <b-col md="4">
                    <label><strong>LOCATION</strong></label>
                    <b-form-select :options="packet.locations" v-model="modalLocationId" @change="fetchDetailedData" class="mb-2">
                    </b-form-select>
                </b-col>
            </b-row>
        </b-card>

        <!-- Location-wise Data Table -->
        <div v-if="locationWiseData.length > 0">
            <h6 class="mb-3">Sales by Location</h6>
            <div style="overflow-x: auto;">
                <b-table striped hover
                        :items="locationWiseData"
                        :fields="locationFields"
                        small
                        style="min-width: 700px;"
                        class="detailed-table">
                    <template #cell(location_name)="data">
                        <b-button
                            variant="link"
                            class="p-0 location-link"
                            @click="showSalespersonModal(data.item)">
                            <strong>{{ data.value || 'N/A' }}</strong>
                        </b-button>
                    </template>
                    <template #cell(total_sold)="data">
                        <strong>{{ data.value || 0 }}</strong>
                    </template>
                    <template #cell(actions)="data">
                        <b-button
                            variant="outline-primary"
                            size="sm"
                            @click="showSalespersonModal(data.item)">
                            <b-icon icon="people-fill"></b-icon> View
                        </b-button>
                    </template>
                </b-table>
            </div>
        </div>

        <div v-else class="text-center py-4">
            <b-alert variant="warning" show>
                <b-icon icon="exclamation-triangle"></b-icon>
                No detailed sales data available for the selected filters
            </b-alert>
        </div>
    </div>
</b-modal>

<b-modal v-model="salespersonModalVisible"
         :title="`Salespeople - ${selectedLocation ? selectedLocation.location_name : 'Location'}`"
         size="lg"
         hide-footer
         centered
         class="salesperson-modal">

  <div v-if="selectedLocation" class="salesperson-content">
    <!-- Location Summary -->
    <b-card class="mb-3">
        <b-row>
            <b-col>
                <strong>Location:</strong> {{ selectedLocation.location_name }}
            </b-col>
            <b-col>
                <strong>Total Sold:</strong> {{ selectedLocation.total_sold || 0 }}
            </b-col>
            <b-col>
                <strong>Salespeople:</strong> {{ salespersonData.length }}
            </b-col>
        </b-row>
    </b-card>

    <!-- Salesperson Table -->
    <div class="table-scroll-container salesperson-table-container" v-if="salespersonData.length > 0">
        <b-table striped hover
                :items="salespersonData"
                :fields="salespersonFields"
                small
                class="salesperson-table">
            <template #cell(salesperson)="data">
                <b-badge variant="outline-primary">{{ data.value || 'N/A' }}</b-badge>
            </template>
            <template #cell(total_sold)="data">
                <strong>{{ data.value || 0 }}</strong>
            </template>
        </b-table>
    </div>

    <div v-else class="text-center py-4">
        <b-alert variant="info" show>
            <b-icon icon="info-circle"></b-icon>
            No salesperson data available for this location
        </b-alert>
    </div>

    <!-- Modal Actions -->
    <div class="modal-actions mt-3">
        <b-button variant="outline-secondary" @click="salespersonModalVisible = false">
            Close
        </b-button>
    </div>
  </div>
</b-modal>

        <!-- NEW: Sold Details Modal -->
          <b-modal id="modal-sold1-details" scrollable
            :title="`SOLD TRANSACTIONS - ${selectedProduct ? selectedProduct.product_name : ''} (${selectedProduct ? selectedProduct.sku : ''})`"
            size="xl"
            hide-footer
            style="min-height: 700px;">

        <div v-if="selectedProduct" class="sold-details-modal">
            <!-- Summary Card -->
            <b-card class="mb-3 bg-light">
                <b-row>
                    <b-col>
                        <strong>Total Transactions:</strong> {{ filteredSoldDetails.length }}
                    </b-col>
                    <b-col>
                        <strong>Total Revenue:</strong> ${{ getTotalRevenue.toFixed(2) }}
                    </b-col>
                    <b-col>
                        <strong>Average Sold Price:</strong> ${{ getAverageSoldPrice.toFixed(2) }}
                    </b-col>
                </b-row>
            </b-card>

            <!-- UPDATED: Sold Details Filters with Date Range -->
            <!-- UPDATED: Sold Details Filters in Single Row -->
                <b-card class="mb-3">
                    <b-row class="filters-row align-items-end">
                           <b-col md="auto" class="flex-grow-1">
                            <label class="small mb-1"><strong>DATE RANGE</strong></label></br>
                            <date-picker
                                v-model="soldDateRange"
                                type="date"
                                range
                                placeholder="Select date range"
                                value-type="YYYY-MM-DD"
                                format="MMM DD, YYYY"
                                @input="applySoldDetailsFilters"
                                class="mb-2"
                                style="width:200px !important;">
                            </date-picker>
                        </b-col>

                        <b-col md="auto">
                            <label class="small mb-1"><strong>LOCATION</strong></label></br>
                            <b-form-select
                                :options="locationOptions"
                                v-model="soldLocationFilter"
                                @change="applySoldDetailsFilters"
                                class="mb-2"
                                style="width: 200px;">
                            </b-form-select>
                        </b-col>
                        <b-col md="auto">
                            <label class="small mb-1"><strong>SALESPERSON</strong></label></br>
                            <b-form-select
                                :options="salespersonOptions"
                                v-model="salesPersonFilter"
                                @change="applySoldDetailsFilters"
                                class="mb-2"
                                style="width: 200px;">
                            </b-form-select>
                        </b-col>
                        <b-col md="auto">
                            <label class="small mb-1"><strong>INVOICE NUMBER</strong></label>
                            <b-form-input
                                v-model="invoiceNumberFilter"
                                placeholder="Search invoice"
                                @input="applySoldDetailsFilters"
                                debounce="300"
                                class="mb-2"
                                style="min-width: 140px;">
                            </b-form-input>
                        </b-col>

                        <b-col md="auto" class="align-self-end">
                            <b-button
                                v-if="hasActiveSoldDetailsFilters"
                                variant="outline-danger"
                                size="sm"
                                @click="clearSoldDetailsFilters"
                                class="mb-2">
                                <b-icon icon="x-circle"></b-icon> Clear
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row v-if="hasActiveSoldDetailsFilters" class="mt-2">
                        <b-col>
                            <small class="text-muted">
                                Showing {{ filteredSoldDetails.length }} of {{ soldDetails.length }} transactions
                            </small>
                        </b-col>
                    </b-row>
                </b-card>
                <!-- Sold Details Table -->
                <div v-if="filteredSoldDetails.length > 0" style="overflow-x: auto">
                    <b-table striped hover
                            :items="filteredSoldDetails"
                            :fields="soldDetailsFields"
                            small
                            class="sold-details-table">
                        <template #cell(sold_date)="data">
                            {{ formatDate(data.value) }}
                        </template>
                        <template #cell(invoice_number)="data">
                            <a :href="`#/sales/viewsale/${data.value}/`"
                               target="_blank"
                               class="invoice-link"
                               @click.stop>
                                {{ data.value }}
                            </a>
                        </template>
                        <template #cell(price)="data">
                            ${{ data.value.toFixed(2) }}
                        </template>
                        <template #cell(sold_price)="data">
                            ${{ data.value.toFixed(2) }}
                        </template>
                        <template #cell(discount)="data">
                            {{ data.value }}%
                        </template>
                    </b-table>
                </div>

                <div v-else class="text-center py-4">
                    <b-alert variant="info" show>
                        <b-icon icon="info-circle"></b-icon>
                        No individual sales transactions found
                        <span v-if="hasActiveSoldDetailsFilters"> matching your filters</span>
                    </b-alert>
                </div>
            </div>
        </b-modal>

        <!-- Loading State -->
        <div v-if="items_being_loaded == true">
            <loading :active="items_being_loaded"
                :can-cancel="false"
                :is-full-page="true">
            </loading>
        </div>

        <div v-else>
            <!-- Header Controls -->
            <div class="mb-3">
                <!-- Search Filter -->
                <b-alert variant="success" show style="display: inline-block; margin-left: 10px;">
                    <div>SEARCH BY NAME OR SKU</div>
                    <b-form-input
                        v-model="searchQuery"
                        placeholder="Type product name or SKU..."
                        @input="applyFilters"
                        style="width: 300px; max-width: 300px;"
                        debounce="300">
                    </b-form-input>
                </b-alert>

                <b-alert variant="success" show style="display: inline-block; margin-left: 10px;">
                    <div>CATEGORY</div>
                    <b-form-select :options="packet.categories" v-model="category_id" @change="applyFilters" style="width: 100%; max-width: 250px;">
                    </b-form-select>
                </b-alert>
            </div>

            <!-- Results Count -->
            <!-- <div v-if="items.length > 0" class="mb-2">
                <b-badge variant="info" class="p-2">
                    Showing {{ filtered_final.length }} of {{ items.length }} products
                    <span v-if="searchQuery"> matching "{{ searchQuery }}"</span>
                </b-badge>
            </div> -->

            <!-- SUMMARY VIEW -->
            <div v-if="items.length > 0" class="diver">
                <table style="width: 100%;">
                    <thead>
                        <tr show style="">
                            <th class="srr" style="width: 300px;">ITEM DESCRIPTION</th>
                            <th class="srr" style="width: 180px;">ITEM SKU</th>
                            <th class="srr" style="width: 180px;">CATEGORY</th>
                            <th class="srr" style="width: 100px;">7 DAYS</th>
                            <th class="srr" style="width: 100px;">30 DAYS</th>
                            <th class="srr" style="width: 100px;">60 DAYS</th>
                            <th class="srr" style="width: 100px;">90 DAYS</th>
                            <th class="srr" style="width: 100px;">120 DAYS</th>
                            <th class="srr" style="width: 100px;">ALL TIME</th>
                            <th class="srr" style="width: 220px;">ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in filtered_final" :key="idx">
                            <td class="srrv">{{ item.product_name }}</td>
                            <td class="srrv">{{ item.sku }}</td>
                            <td class="srrv">{{ packet.categoriesdict[item.category_id] }}</td>
                            <td class="srrv">{{ item.sold_7d || 0 }}</td>
                            <td class="srrv">{{ item.sold_30d || 0 }}</td>
                            <td class="srrv">{{ item.sold_60d || 0 }}</td>
                            <td class="srrv">{{ item.sold_90d || 0 }}</td>
                            <td class="srrv">{{ item.sold_120d || 0 }}</td>
                            <td class="srrv">{{ item.sold_so_far || 0 }}</td>
                            <td class="srrv">
                                <b-button size="sm" variant="outline-primary" @click="showDetailedView(item)" class="mr-1">
                                    <b-icon icon="search"></b-icon> DETAILS
                                </b-button>
                                <!-- NEW: Sold Details Button -->
                                <b-button size="sm" variant="outline-success" @click="showSoldDetails(item)">
                                    <b-icon icon="receipt"></b-icon> PRICE DETAILS
                                </b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="items.length === 0 && !items_being_loaded">
                <b-alert variant="warning" show>
                    <b-icon icon="exclamation-triangle"></b-icon>
                    No selling history data available
                </b-alert>
            </div>

            <!-- No Results Message -->
            <div v-if="items.length > 0 && filtered_final.length === 0" class="text-center py-4">
                <b-alert variant="info" show>
                    <b-icon icon="search"></b-icon>
                    No products found matching your search criteria.
                    <b-button variant="outline-info" size="sm" @click="clearFilters" class="ml-2">
                        Clear filters
                    </b-button>
                </b-alert>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import Requestor from "@/utilities/Requestor";
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    import DatePicker from 'vue2-datepicker'; // Import the date picker
    import 'vue2-datepicker/index.css'; // Import the styles
    import 'vue2-datepicker/locale/en';

    export default {
        name: "ProductsSellingHistory",
        components: {
            Loading,DatePicker
        },
        data: function() {
            return {
                packet: {},
                items: [],
                detailedItems: [],
                soldDetails: [], // NEW: Array for individual sales transactions
                items_being_loaded: false,
                selectedProduct: null,

                // Main filters
                dateRange: 'all_time',
                category_id: null,
                location_id: null,
                searchQuery: '',
                salespersonModalVisible: false,
        selectedLocation: null,
        salespersonData: [],

        // Fields for location and salesperson tables
        locationFields: [
            {
                key: 'location_name',
                label: 'STORE LOCATION',
                sortable: true,
                thStyle: { width: '200px' }
            },
            { key: 'sold_7d', label: '7 DAYS', sortable: true },
            { key: 'sold_30d', label: '30 DAYS', sortable: true },
            { key: 'sold_90d', label: '90 DAYS', sortable: true },
            { key: 'total_sold', label: 'TOTAL SOLD', sortable: true },
            {
                key: 'actions',
                label: 'ACTIONS',
                thStyle: { width: '150px' }
            }
        ],

        salespersonFields: [
            {
                key: 'salesperson',
                label: 'SALESPERSON',
                sortable: true,
                thStyle: { width: '200px' }
            },
            { key: 'sold_7d', label: '7 DAYS', sortable: true },
            { key: 'sold_30d', label: '30 DAYS', sortable: true },
            { key: 'sold_90d', label: '90 DAYS', sortable: true },
            { key: 'total_sold', label: 'TOTAL SOLD', sortable: true }
        ],
                // Modal filters
                modalDateRange: 'all_time',
                modalLocationId: null,
                soldDateRange: [],
                // NEW: Sold details filters
                soldDateFilter: null,
                soldLocationFilter: null,
                invoiceNumberFilter: '',
                salesPersonFilter: '',
                locationOptions: [],
                salespersonOptions: [],
                alesPersonFilter: null,

                // Table fields for detailed view
                detailedFields: [
                    {
                        key: 'location_name',
                        label: 'STORE LOCATION',
                        sortable: true,
                        thStyle: { width: '180px' },
                        tdClass: 'wide-location-column'
                    },
                    {
                        key: 'salesperson',
                        label: 'SALESPERSON',
                        sortable: true,
                        thStyle: { width: '150px' },
                        tdClass: 'wide-salesperson-column'
                    },
                    { key: 'sold_7d', label: '7 DAYS', sortable: true },
                    { key: 'sold_30d', label: '30 DAYS', sortable: true },
                    { key: 'sold_60d', label: '60 DAYS', sortable: true },
                    { key: 'sold_90d', label: '90 DAYS', sortable: true },
                    { key: 'sold_120d', label: '120 DAYS', sortable: true },
                    { key: 'total_sold', label: 'TOTAL SOLD', sortable: true }
                ],

                // NEW: Fields for sold details modal
                soldDetailsFields: [
                    {
                        key: 'sold_date',
                        label: 'SOLD DATE',
                        sortable: true,
                        thStyle: { width: '120px' }
                    },
                    {
                        key: 'store_location',
                        label: 'STORE LOCATION',
                        sortable: true,
                        thStyle: { width: '150px' }
                    },
                    {
                        key: 'invoice_number',
                        label: 'INVOICE NUMBER',
                        sortable: true,
                        thStyle: { width: '130px' }
                    },
                    {
                        key: 'salesperson_name',
                        label: 'SALESPERSON',
                        sortable: true,
                        thStyle: { width: '140px' }
                    },
                    {
                        key: 'price',
                        label: 'PRICE',
                        sortable: true,
                        thStyle: { width: '100px' },
                        // tdClass: 'text-right'
                    },
                    {
                        key: 'sold_price',
                        label: 'SOLD PRICE',
                        sortable: true,
                        thStyle: { width: '110px' },
                        // tdClass: 'text-right'
                    },
                    {
                        key: 'discount',
                        label: 'DISCOUNT',
                        sortable: true,
                        thStyle: { width: '100px' },
                        // tdClass: 'text-right'
                    }
                ],

                dateRangeOptions: [
                    { value: '7_days', text: 'LAST 7 DAYS' },
                    { value: '30_days', text: 'LAST 30 DAYS' },
                    { value: '60_days', text: 'LAST 60 DAYS' },
                    { value: '90_days', text: 'LAST 90 DAYS' },
                    { value: '120_days', text: 'LAST 120 DAYS' },
                    { value: 'all_time', text: 'ALL TIME' }
                ]
            }
        },
        computed: {
           locationWiseData() {
        const locationMap = new Map();

        this.detailedItems.forEach(item => {
            const locationId = item.location_id;
            const locationName = item.location_name || 'Unknown Location';

            if (!locationMap.has(locationId)) {
                locationMap.set(locationId, {
                    location_id: locationId,
                    location_name: locationName,
                    sold_7d: 0,
                    sold_30d: 0,
                    sold_90d: 0,
                    total_sold: 0
                });
            }

            const locationData = locationMap.get(locationId);
            locationData.sold_7d += item.sold_7d || 0;
            locationData.sold_30d += item.sold_30d || 0;
            locationData.sold_90d += item.sold_90d || 0;
            locationData.total_sold += item.total_sold || 0;
        });

        return Array.from(locationMap.values()).sort((a, b) => b.total_sold - a.total_sold);
    },

    getDetailedTotalSold() {
        return this.detailedItems.reduce((sum, item) => sum + (item.total_sold || 0), 0);
    },

    getUniqueLocations() {
        const locations = new Set(this.detailedItems.map(item => item.location_name).filter(Boolean));
        return locations.size;
    },

    getUniqueSalespeople() {
        const salespeople = new Set(this.detailedItems.map(item => item.salesperson).filter(Boolean));
        return salespeople.size;
    },
            filtered_final: function() {
                let items = this.items;

                if (this.category_id) {
                    items = items.filter(item => item.category_id == this.category_id);
                }

                if (this.searchQuery) {
                    const query = this.searchQuery.toLowerCase().trim();
                    items = items.filter(item =>
                        item.product_name.toLowerCase().includes(query) ||
                        item.sku.toLowerCase().includes(query)
                    );
                }

                return items.slice(0, 300);
            },

            getTotalSold: function() {
                return this.detailedItems.reduce((sum, item) => sum + (item.total_sold || 0), 0);
            },

            getAverageSold: function() {
                return this.detailedItems.length > 0
                    ? Math.round(this.getTotalSold / this.detailedItems.length)
                    : 0;
            },

            // NEW: Computed properties for sold details
            getTotalRevenue: function() {
                return this.filteredSoldDetails.reduce((sum, item) => sum + (item.sold_price || 0), 0);
            },

            getAverageSoldPrice: function() {
                return this.filteredSoldDetails.length > 0
                    ? this.getTotalRevenue / this.filteredSoldDetails.length
                    : 0;
            },

            hasActiveFilters: function() {
                return this.category_id !== null || this.searchQuery !== '';
            },

            // NEW: Filter sold details based on filters
            filteredSoldDetails: function() {
                let items = this.soldDetails;

                // Filter by date range
                if (this.soldDateRange && this.soldDateRange.length === 2) {
                    const startDate = moment(this.soldDateRange[0]);
                    const endDate = moment(this.soldDateRange[1]);

                    items = items.filter(item => {
                        const soldDate = moment(item.sold_date);
                        return soldDate.isBetween(startDate, endDate, 'day', '[]'); // inclusive
                    });
                }

                // Filter by location
                if (this.soldLocationFilter) {
                    items = items.filter(item =>
                        item.store_location_id == this.soldLocationFilter
                    );
                }

                // UPDATED: Filter by salesperson - fixed property name
                if (this.salesPersonFilter) {
                    items = items.filter(item =>
                        item.salesperson_id == this.salesPersonFilter
                    );
                }

                // Filter by invoice number
                if (this.invoiceNumberFilter) {
                    const query = this.invoiceNumberFilter.toLowerCase().trim();
                    items = items.filter(item =>
                        item.invoice_number.toLowerCase().includes(query)
                    );
                }

                return items;
            },


            // NEW: Check if any sold details filters are active
              hasActiveSoldDetailsFilters: function() {
                return (this.soldDateRange && this.soldDateRange.length === 2) ||
                       this.soldLocationFilter !== null ||
                       this.soldPersonFilter !== null ||
                       this.invoiceNumberFilter !== '';
            }
        },
        methods: {
          showSalespersonModal(location) {
        if (!location || !location.location_id) {
            console.error('Invalid location data provided to showSalespersonModal:', location);
            this.$bvToast.toast('Invalid location data', {
                variant: 'warning',
                title: 'Error'
            });
            return;
        }

        console.log('Opening salesperson modal for location:', location.location_name);

        // Set the selected location
        this.selectedLocation = { ...location };

        // Get salesperson data for this location
        this.salespersonData = this.getSalespersonDataForLocation(location.location_id);

        // Show the modal
        this.salespersonModalVisible = true;

        console.log('Salesperson data loaded:', this.salespersonData.length, 'records');
    },

    // Get salesperson data for a specific location
    getSalespersonDataForLocation(locationId) {
        if (!this.detailedItems || this.detailedItems.length === 0) {
            console.warn('No detailed items available for location:', locationId);
            return [];
        }

        const salespersonMap = new Map();

        this.detailedItems
            .filter(item => item.location_id === locationId)
            .forEach(item => {
                const salesperson = item.salesperson || 'Unknown Salesperson';

                if (!salespersonMap.has(salesperson)) {
                    salespersonMap.set(salesperson, {
                        salesperson: salesperson,
                        sold_7d: 0,
                        sold_30d: 0,
                        sold_90d: 0,
                        total_sold: 0
                    });
                }

                const salespersonData = salespersonMap.get(salesperson);
                salespersonData.sold_7d += item.sold_7d || 0;
                salespersonData.sold_30d += item.sold_30d || 0;
                salespersonData.sold_90d += item.sold_90d || 0;
                salespersonData.total_sold += item.total_sold || 0;
            });

        const result = Array.from(salespersonMap.values()).sort((a, b) => b.total_sold - a.total_sold);
        console.log(`Found ${result.length} salespeople for location ${locationId}`);
        return result;
    },

    // Update the detailed view to show location-wise data first
    showDetailedView(item) {
        this.selectedProduct = item;
        this.modalDateRange = this.dateRange;
        this.modalLocationId = this.location_id;

        this.fetchDetailedData();
        this.$bvModal.show('modal-detailed-view');
    },
    // },
    //         showDetailedView(item) {
    //             this.selectedProduct = item;
    //             this.modalDateRange = this.dateRange;
    //             this.modalLocationId = this.location_id;

    //             this.fetchDetailedData();
    //             this.$bvModal.show('modal-detailed-view');
    //         },

            // NEW: Show sold details modal
            showSoldDetails(item) {
                this.selectedProduct = item;
                // Reset filters when opening modal
                this.clearSoldDetailsFilters();
                this.fetchSoldDetails();
                this.$bvModal.show('modal-sold1-details');
            },

            // NEW: Fetch individual sales transactions
            fetchSoldDetails() {
                if (!this.selectedProduct) return;

                let that = this;
                let path = "/api/product/get_selling_history/";
                let data = {
                    product_sku: this.selectedProduct.sku,
                    view_type: 'sold_details'
                };

                let s = function(response) {
                    if (response.data.result) {
                        that.soldDetails = response.data.result;

                        // DEBUG: Log the received data
                        console.log('Sold Details Data:', response.data.result);
                        console.log('First item structure:', response.data.result[0]);

                        // Extract unique locations and salespeople for dropdowns
                        that.extractFilterOptions(response.data.result);

                        // DEBUG: Log the generated options
                        console.log('Location Options:', that.locationOptions);
                        console.log('Salesperson Options:', that.salespersonOptions);
                    } else {
                        that.$bvToast.toast(
                            response.data.error || "Error fetching sold details",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        that.soldDetails = [];
                    }
                };

                let f = function(error) {
                    console.log('Error fetching sold details:', error);
                    that.$bvToast.toast(
                        "Error fetching sold details",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.soldDetails = [];
                };

                Requestor.getSyncP(path, data, this, s, f);
            },

            extractFilterOptions(soldDetails) {
                // Extract unique locations
                const locationsMap = new Map();
                const salespeopleMap = new Map();

                soldDetails.forEach(item => {
                    // Locations - handle cases where data might be null/undefined
                    if (item.store_location_id && item.store_location) {
                        locationsMap.set(item.store_location_id, {
                            value: item.store_location_id,
                            text: item.store_location
                        });
                    } else if (item.store_location) {
                        // If no ID but has location name, use name as value
                        locationsMap.set(item.store_location, {
                            value: item.store_location,
                            text: item.store_location
                        });
                    }

                    // Salespeople - handle cases where data might be null/undefined
                    if (item.salesperson_id && item.salesperson_name) {
                        salespeopleMap.set(item.salesperson_id, {
                            value: item.salesperson_id,
                            text: item.salesperson_name
                        });
                    } else if (item.salesperson_name) {
                        // If no ID but has name, use name as value
                        salespeopleMap.set(item.salesperson_name, {
                            value: item.salesperson_name,
                            text: item.salesperson_name
                        });
                    }
                });

                // Convert to arrays and add "ALL" option
                this.locationOptions = [
                    { value: null, text: "ALL LOCATIONS" },
                    ...Array.from(locationsMap.values())
                ];

                this.salespersonOptions = [
                    { value: null, text: "ALL SALESPERSONS" },
                    ...Array.from(salespeopleMap.values())
                ];

                // If no locations found, show a message
                if (this.locationOptions.length === 1) {
                    this.locationOptions.push({ value: 'no_data', text: 'No location data', disabled: true });
                }

                // If no salespeople found, show a message
                if (this.salespersonOptions.length === 1) {
                    this.salespersonOptions.push({ value: 'no_data', text: 'No salesperson data', disabled: true });
                }
            },
            // NEW: Format date for display
            formatDate(dateString) {
                return moment(dateString).format('MMM DD, YYYY');
            },

            // NEW: Apply sold details filters
            applySoldDetailsFilters() {
                // Computed property will automatically update
            },

            // NEW: Clear sold details filters
            clearSoldDetailsFilters() {
                this.soldDateRange = [];
                this.soldLocationFilter = null;
                this.salesPersonFilter = null; // Fixed property name
                this.invoiceNumberFilter = '';
            },

            applyFilters() {
                // This will trigger the computed property to update
            },

            clearFilters() {
                this.category_id = null;
                this.searchQuery = '';
            },

            fetch_init(first) {
                if (first) {
                    this.category_id = null;
                    this.location_id = null;
                    this.dateRange = 'all_time';
                    this.searchQuery = '';
                }
                this.fetchSummaryData();
            },

            fetchSummaryData() {
                let that = this;
                let path = "/api/product/get_selling_history/";
                let data = {
                    date_range: this.dateRange,
                    category_id: this.category_id,
                    location_id: this.location_id,
                    view_type: 'summary'
                };

                let s = function(response) {
                    if (response.data.result) {
                        that.items = response.data.result.map(item => ({
                            ...item,
                            sold_7d: item.sold_7d || 0,
                            sold_30d: item.sold_30d || 0,
                            sold_60d: item.sold_60d || 0,
                            sold_90d: item.sold_90d || 0,
                            sold_120d: item.sold_120d || 0,
                            sold_so_far: item.sold_so_far || 0
                        }));
                    } else {
                        that.$bvToast.toast(
                            response.data.error || "Error fetching selling history",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                };

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error fetching selling history",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                };

                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },

            fetchDetailedData() {
                if (!this.selectedProduct) return;

                let that = this;
                let path = "/api/product/get_selling_history/";
                let data = {
                    date_range: this.modalDateRange,
                    category_id: this.category_id,
                    location_id: this.modalLocationId,
                    product_sku: this.selectedProduct.sku,
                    view_type: 'detailed'
                };

                let s = function(response) {
                    if (response.data.result) {
                        that.detailedItems = response.data.result;
                    } else {
                        that.$bvToast.toast(
                            response.data.error || "Error fetching detailed history",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        that.detailedItems = [];
                    }
                };

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error fetching detailed history",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.detailedItems = [];
                };

                Requestor.getSyncP(path, data, this, s, f);
            },

            exportDetailedData() {
                this.$bvToast.toast(
                    "Export feature coming soon!",
                    {title: "Info", autoHideDelay: 1500, variant:"info"}
                );
            }
        },
          created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.categories.splice(0, 0, {value: null, text: "ALL"});
            this.packet.locations.splice(0, 0, {value: null, text: "ALL"});
            this.packet.userDetails = JSON.parse(localStorage.userDetails);

            // Initialize filter options
            this.locationOptions = [{ value: null, text: "ALL LOCATIONS" }];
            this.salespersonOptions = [{ value: null, text: "ALL SALESPERSONS" }];

            this.fetch_init(true);
        }
    }
</script>

<style scoped>
.mx-datepicker {
    width: 100%;
}

.mx-input {
    height: 38px;
    font-size: 14px;
    width:100px !important;
}

/* Ensure dropdowns have proper styling */
.b-form-select {
    height: 38px;
    font-size: 14px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .filters-row .col-md-3 {
        margin-bottom: 10px;
    }
}
.wide-location-column {
    min-width: 180px;
}

.wide-salesperson-column {
    min-width: 150px;
}

.diver {
    overflow: auto;
    width: 100%;
    height: 600px;
}

td, th {
    border: 1px solid;
}

th {
    background-color: white;
}

table {
    table-layout: fixed;
    width: 100%;
}

.srr {
    font-size: 13px;
    text-align: center;
    background: #ffeaa7;
    border: 1px solid #010101;
    font-weight: bold;
}

.srrv {
    font-size: 12px;
    text-align: center;
    background: white;
    border: 1px solid #010101;
    padding: 5px;
}

.filters-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: end;
}

.detailed-table {
    font-size: 12px;
}

.detailed-table >>> .table th {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
}

/* NEW: Styles for sold details table */
.sold-details-table {
    font-size: 11px;
}

.sold-details-table >>> .table th {
    background-color: #e9ecef;
    border: 1px solid #dee2e6;
}

.text-right {
    text-align: right;
}

/* NEW: Style for invoice number hyperlink */
.invoice-link {
    color: #007bff;
    text-decoration: none;
    font-weight: 500;
}

.invoice-link:hover {
    color: #0056b3;
    text-decoration: underline;
}

/* Style for search input */
.search-highlight {
    background-color: yellow;
    font-weight: bold;
}

/* Button spacing */
.mr-1 {
    margin-right: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Products/ProductsSellingHistory.vue